/* eslint-disable sort-keys */
import { RoleInput, RoleReportInput, UserInput, UserReportInput } from 'generated/graphql-types';
import { roleReportsFields } from 'src/app/pages/report-permissions-list/models/report-permission.model';
import { userReportsFields } from 'src/app/pages/report-permissions-list/models/user-report-permission.model';
import { RoleDetailSaveModel } from 'src/app/pages/role-details/models/role-detail-save.model';
import { UserDetailSaveModel } from 'src/app/pages/user-details/models/user-detail-save.model';

export function handleRoleReports(role: RoleDetailSaveModel, roleInput: RoleInput, fields: string[]): void {
   if (role.roleReports && role.roleReports['added'] && role.roleReports['added'].length) {
      const formattedRoleReportsFields: (keyof RoleReportInput)[] = [];

      formatRoleReportsFields(formattedRoleReportsFields, 'roleReports', roleReportsFields);
      fields.push(
         ...formattedRoleReportsFields.map((field) => {
            return `${field}`;
         })
      );

      roleInput.roleReports = role.roleReports['added'].map((value: any) => {
         return { roleId: role.roleId, reportId: value, fields: ['roleId', 'reportId'] };
      });
   } else {
      roleInput.roleReports = null;
   }
}

export function formatRoleReportsFields(fields: string[], key: string, embedFields: (keyof RoleReportInput)[]): void {
   if (key) {
      for (const embedField of embedFields) {
         fields.push(`${key}.${embedField}`);
      }
   }
}

export function handleUserReports(user: UserDetailSaveModel, userInput: UserInput, fields: string[]): void {
   if (user.userReports && user.userReports['added'] && user.userReports['added'].length) {
      const formattedUserReportsFields: (keyof UserReportInput)[] = [];

      formatUserReportsFields(formattedUserReportsFields, 'userReports', userReportsFields);
      fields.push(
         ...formattedUserReportsFields.map((field) => {
            return `${field}`;
         })
      );

      userInput.userReports = user.userReports['added'].map((value: any) => {
         return { userId: user.userId, reportId: value, fields: ['userId', 'reportId'] };
      });
   } else {
      userInput.userReports = null;
   }
}

export function formatUserReportsFields(fields: string[], key: string, embedFields: (keyof UserReportInput)[]): void {
   if (key) {
      for (const embedField of embedFields) {
         fields.push(`${key}.${embedField}`);
      }
   }
}
